import SelectField from "./select-field";
import { Controller } from "react-hook-form";
import { selectFieldProps } from "./select-field.type";
import AdditionalFormFields from "../common-type";

const SelectFormField = (props) => {
  const {
    name,
    control,
    options,
    placeholder = "",
    label = "",
    multiple = false,
    defaultValue,
    isRequired,
    disabled,
    customOnChange, // <- your custom handler
  } = props;

  const defaultValueForward = defaultValue ? defaultValue : multiple ? [] : "";

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValueForward}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <SelectField
          name={name}
          options={options}
          error={error}
          onChange={(e) => {
            onChange(e);
            if (customOnChange) {
              customOnChange(e);
            }
          }}
          value={value}
          placeholder={placeholder}
          label={label}
          multiple={multiple}
          isRequired={isRequired}
          defaultValue={defaultValueForward}
          disabled={disabled}
        />
      )}
    />
  );
};

SelectFormField.propTypes = { ...selectFieldProps, ...AdditionalFormFields };

export default SelectFormField;
